module.exports = __webpack_public_path__ + "img/184.8433ad47.jpg";